<template>
  <div class="coupon-list-popup">
    <div class="coupon-list-popup-shade" @click="hidePopup"></div>
    <div class="coupon-list-popup-content">
      <p class="coupon-list-popup-title">{{ letter.quanGift }}</p>
      <p class="coupon-list-popup-type-tip">{{ letter.quanGiftTips }}</p>
      <div class="coupon-list-popup-content-scroll">
        <coupon-item
          v-for="item in couponList"
          :key="item.COUPON_ID"
          :info="item"
          :active="false"
          :invalid="true"
          @closePopup="hidePopup"
        ></coupon-item>
      </div>
      <a
        class="coupon-list-popup-close j-click-coupon-close"
        href="javascript:;"
        @click="hidePopup"
      ></a>
    </div>
  </div>
</template>

<script type="text/javascript">
import CouponItem from '@components/officialTopup/coupon/CouponItem.vue';
export default {
  name: 'couponBirthPopup',
  props: ['couponList'],
  computed: {
    letter() {
      return this.$store.state.letter;
    }
  },
  methods: {
    hidePopup() {
      this.$emit('closeCouponPopup');
    }
  },
  components: {
    CouponItem
  }
};
</script>

<style scoped lang="scss">
@import '@assets/scss/officialTopup/officialTopup.scss';
.coupon-list-popup {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  // 层级高过CouponVipPopup.vue组件，优先弹出该生日弹
  z-index: 1003;

  &-shade {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
  }
  &-content {
    position: absolute;
    left: 50%;
    top: 50%;
    box-sizing: border-box;
    width: 708px;
    transform: translate(-50%, -50%);
    background: $backgroundColor;
    border-radius: 20px;
    &-scroll {
      height: 780px;
      overflow: -moz-scrollbars-none;
      overflow-y: scroll;
      position: relative;
      // max-height: 90%;
      -ms-overflow-style: none;
      scrollbar-width: none;
      padding: 3px 20px 20px;
      &::-webkit-scrollbar {
        display: none;
        width: 0 !important;
      }
    }
  }
  &-title {
    line-height: 80px;
    height: 80px;
    text-align: center;
    font-size: 26px;
    @include g-popup-title();
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
  }
  &-type-wrap {
    display: flex;
    justify-content: center;
    height: 80px;
    align-items: center;
    border-bottom: 1px solid $border;
  }
  &-type {
    font-size: 24px;
    color: #333;
    width: 50%;
    text-align: center;
    cursor: pointer;
    &:hover {
      color: $themeColor;
    }
    &.active {
      color: $themeColor;
    }
    &-line {
      border-left: 1px solid $border;
      height: 27px;
      vertical-align: middle;
      border-top: 0;
    }
    &-tip {
      font-size: 22px;
      color: #333;
      padding: 30px 0;
      text-align: center;
      max-height: 999999px;
    }
  }
  &-close {
    position: absolute;
    right: 32px;
    top: 27px;
    background: url($commonImg + 'close.png') no-repeat;
    width: 28px;
    height: 28px;
    cursor: pointer;
  }
}
@media screen and (orientation: landscape) {
  .coupon-list-popup {
    &-content {
      width: $landscapePopupWidth;
      &-scroll {
        height: 291px;
        padding: 3px 18px 18px;
      }
    }
    &-title {
      height: 61px;
      line-height: 61px;
      font-size: 22px;
    }
    &-type-wrap {
      display: flex;
      justify-content: center;
      height: 60px;
      align-items: center;
    }
    &-type {
      font-size: 18px;
      color: #333;
      width: 50%;
      text-align: center;
      &-line {
        height: 27px;
        vertical-align: middle;
        border-top: 0;
      }
      &-tip {
        font-size: 16px;
        color: #333;
        padding: 20px 0;
        text-align: center;
        max-height: 999999px;
      }
    }

    &-close {
      position: absolute;
      right: 15px;
      top: 19px;
      background: url($commonImg + 'close.png') no-repeat;
      width: 23px;
      height: 23px;
      cursor: pointer;
      background-size: cover;
    }
  }
}

@media only screen and (min-height: 640px) and (orientation: landscape) {
  .coupon-list-popup-content-scroll {
    height: 391px;
  }
}
/* iPad纵向方向样式 */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
  .coupon-list-popup-content-scroll {
    height: 500px;
  }
}
</style>
